import { ApiBase } from "~/extensions/api";
import { FindKeiyakushaCommand } from "./commands/FindKeiyakushaCommand";
export class KeiyakushaApi extends ApiBase {
    /**検索API */
    find(model, pagination) {
        let command = new FindKeiyakushaCommand(model);
        pagination.applyTo(command);
        return this.request(command);
    }
}
